/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('BoardSkipperController', BoardSkipperController);

    BoardSkipperController.$inject = ['skipperLevels', '$scope', '$rootScope', '$state', 'Skipper', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Principal'];

    function BoardSkipperController(skipperLevels, $scope, $rootScope, $state, Skipper, ParseLinks, AlertService, paginationConstants, pagingParams, Principal) {

        var vm = this;

        $rootScope.skipperObj = {};
        $rootScope.skipperObj.query = null;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.pageSize = pagingParams.pageSize === 'all' ? paginationConstants.all : pagingParams.pageSize;
        vm.itemsPerPage = vm.pageSize;
        vm.allItems = paginationConstants.all;
        vm.loadAll = loadAll;
        vm.matchAny = pagingParams.matchAny;
        vm.levels = pagingParams.levels;
        vm.query = pagingParams.query;
        vm.loadQuery = pagingParams.loadQuery;
        vm.anySelected = anySelected;
        vm.selectAll = selectAll;
        vm.selectNone = selectNone;
        vm.transitionToQuery = transitionToQuery;
        vm.transitionToLevels = transitionToLevels;
        vm.copyFilterToQuery = copyFilterToQuery;

        vm.supportedOperators = {
            "(": "LEFT_PARENTHESIS",
            ")": "RIGHT_PARENTHESIS",
            "!": "NOT",
            "not": "NOT",
            "&": "AND",
            "&&": "AND",
            "and": "AND",
            "und": "AND",
            "|": "OR",
            "||": "OR",
            "or": "OR",
            "oder": "OR"
        };
        vm.memberValues = {
            "probe": "Probemitglieder",
            "voll": "Vollmitglieder",
            "member": "Alle Mitglieder (Probe & Voll)",
            "mitglied": "Alle Mitglieder (Probe & Voll)",
            "guest": "Gastmitglieder",
            "gast": "Gastmitglieder",
            "student": "Studenten"
        }
        vm.skipperLevelValues = {
            "candidate": "candidate",
            "Skipperanwärter": "candidate",
            "Anwärter": "candidate",
            "Skipperanwaerter": "candidate",
            "Anwaerter": "candidate",
            "Pre": "candidate",
            "Cand.": "candidate",
            "Cand": "candidate",
            "flottille": "flottille",
            "Flotte": "flottille",
            "vacation": "vacation",
            "Urlaub": "vacation",
            "askew": "askew",
            "sks_co": "sks_co",
            "SKS Co-Skipper": "sks_co",
            "SKS Coskipper": "sks_co",
            "SKS Co": "sks_co",
            "SKSCo": "sks_co",
            "Co": "sks_co",
            "Co-Skipper": "sks_co",
            "Coskipper": "sks_co",
            "sks": "sks",
            "sks_plus": "sks_plus",
            "SKS+": "sks_plus",
            "SKSPlus": "sks_plus",
            "sss": "sss",
            "regatta_beginner": "regatta_beginner",
            "regattabeginner": "regatta_beginner",
            "Einsteiger Regatta": "regatta_beginner",
            "RegBeg": "regatta_beginner",
            "regatta_normal": "regatta_normal",
            "regattanormal": "regatta_normal",
            "Regatta": "regatta_normal",
            "RegNor": "regatta_normal",
            "regatta_advanced": "regatta_advanced",
            "regattaadvanced": "regatta_advanced",
            "Fortgeschrittenen Regatta": "regatta_advanced",
            "RegAdv": "regatta_advanced",
            "regatta_expert": "regatta_expert",
            "regattaexpert": "regatta_expert",
            "Experten Regatta": "regatta_expert",
            "RegExp": "regatta_expert"
        }

        vm.resultingQuery = "";
        vm.error = null;

        vm.skipperLevels = skipperLevels.data;
        vm.skipperLevelsSelected = [];
        for (var index = 0; index < vm.skipperLevels.length; index++) {
            vm.skipperLevelsSelected.push(vm.levels.length === 0 || vm.levels[0] === "" || vm.levels.includes(vm.skipperLevels[index]));
        }

        vm.isBoard = false;
        Principal.hasAuthority('ROLE_BOARD').then(function (result) {
            vm.isBoard = result;
        });
        vm.isSkipperManager = false;
        Principal.hasAuthority('ROLE_SKIPPER_MANAGER').then(function (result) {
            vm.isSkipperManager = result;
        });

        loadAll();

        $scope.status = {
            filterOpen: pagingParams.filterOpen,
            queryOpen: pagingParams.queryOpen,
            queryInfoOpen: pagingParams.queryInfoOpen
        };

        function getLevelsArray() {
            var levels = [];
            if (vm.skipperLevels.length === 0) {
                levels = vm.levels;
            } else {
                for (var index = 0; index < vm.skipperLevelsSelected.length; index++) {
                    if (vm.skipperLevelsSelected[index]) {
                        levels.push(vm.skipperLevels[index]);
                    }
                }
            }
            return levels;
        }

        function getLevels() {
            var levels = getLevelsArray();
            if (levels.length === vm.skipperLevels.length) {
                levels = [];
            }
            return levels.join(',');
        }

        function loadAll () {
            vm.error = null;
            Skipper.query({
                page: pagingParams.page - 1,
                size: vm.pageSize,
                sort: sort(),
                matchAny: vm.matchAny,
                levels: vm.loadQuery ? null : getLevels(),
                query: vm.loadQuery ? vm.query : null
            }, onSuccess, onError);
            function sort() {
                var sorting = vm.reverse ? 'asc' : 'desc';
                var result = [vm.predicate + ',' + sorting];
                if (vm.predicate !== 'id') {
                    result.push('id,' + sorting);
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.resultingQuery = headers('Resulting-Query');
                $rootScope.skipperObj.query = vm.resultingQuery;
                vm.queryCount = vm.totalItems;
                vm.skippers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                if (vm.loadQuery) {
                    vm.error = error.headers('Error-Message');
                    $scope.status.queryOpen = true;
                    AlertService.error(vm.error);
                } else {
                    AlertService.error(error.data.message);
                }
            }
        }

        function anySelected() {
            for (var index = 0; index < vm.skipperLevelsSelected.length; index++) {
                if (vm.skipperLevelsSelected[index]) {
                    return true;
                }
            }
            return false;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                pageSize: vm.pageSize === vm.allItems ? 'all' : vm.pageSize,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                matchAny: vm.matchAny,
                levels: getLevels(),
                query: vm.query,
                loadQuery: vm.loadQuery,
                filterOpen: $scope.status.filterOpen,
                queryOpen: $scope.status.queryOpen
            });
        }

        function setLevelsSelected(value) {
            for (var index = 0; index < vm.skipperLevelsSelected.length; index++) {
                vm.skipperLevelsSelected[index] = value;
            }
        }

        function selectAll() {
            setLevelsSelected(true);
        }

        function selectNone() {
            setLevelsSelected(false);
        }

        function transitionToQuery() {
            vm.loadQuery = true;
            transition();
        }

        function transitionToLevels() {
            vm.loadQuery = false;
            transition();
        }

        function copyFilterToQuery() {
            var connection = vm.matchAny ? " | " : " & ";
            var levels = getLevelsArray();
            vm.query = levels.length === vm.skipperLevels.length && vm.matchAny ? "all" : levels.join(connection);
        }
    }
})();
